import Table from '../actions/components/Table.vue';
import Photo from '../../../components/photo/Photo.vue';
import WebCamModal from '../../../components/WebCamModal.vue';

export default {
  props: ['id'],
  components: { Photo, Table, WebCamModal },
  data() {
    return {
      showDesc: false,
      showTable: false,
      showPhotoForm: false,
      documents: [],
      dialog: {
        active: false,
        content: '',
      },
      openCameraModal: false,
      eventNameFile: '',
      cameraError: '',
      file: { filename: '', base64: '', name: '', url: '', id: null },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    action() {
      return this.$store.state.sales.action;
    },
    isNeedSales() {
      return this.action.need_sales;
    },
    isNeedPhotos() {
      return this.action.need_photos;
    },
    getStatusColor() {
      switch (this.action.status) {
        case 'active': return '#35144b';
        case 'paid': return '#35144b';
        default: return '#35144b';
      }
    },
    showActionProgress() {
      return !!(this.action.is_confirmed && !this.isNeedSales);
    },
    showActionPhotos() {
      return !!(this.isNeedPhotos || this.isNeedSales);
    },
  },
  methods: {
    closeCameraModal() {
      this.file = { filename: '', base64: '', name: '', url: '', id: null };
      this.openCameraModal = false;
    },
    /** Получить timestamp. */
    setUniqueId() {
      return (new Date()).getTime();
    },
    setCameraError(error) {
      console.log('setCameraError', error);
      this.cameraError = !!error;
    },
    setImageFromCamera(file) {
      const data = { target: {
        files: [file],
      } };
      this.OnFilePicked(data);
      this.openCameraModal = false;
    },
    /**
     * Добавление документа к покупке.
     * @param e эвент
     */
    OnFilePicked(e) {
      const app = this;
      const doc = app.file;
      const { files } = e.target;
      if (files[0] !== undefined) {
        const [file] = files;
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        doc.name = file.name;

        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          doc.filename = null;
          doc.id = null;
          doc.base64 = fr.result;
          app.documents.push({ name: doc.name, base64: doc.base64, uid: app.setUniqueId() });
          app.file = { filename: '', base64: '', name: '', url: '', id: null };
          app.$forceUpdate();
        });
      } else {
        this.file = { filename: '', base64: '', name: '', url: '', id: null };
      }
    },
    showPDF(url) {
      this.dialog.active = true;
      this.dialog.content = `<iframe src="${url}" style="width:100%; min-height:700px" frameborder="0"/>`;
    },
    getSaleStatusColor(status) {
      switch (status) {
        case 'redo': return 'color-orange';
        case 'draft': return 'color-orange';
        case 'declined': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        case 'verified': return 'color-green';
        case 'adminReview': return 'color-blue';
        default: return '';
      }
    },
    savePhotos() {
      const app = this;
      const url = !app.isNeedSales && app.action.photo_sales[0]
        && app.action.photo_sales[0].documents.length
        ? 'sales/api/sale/update'
        : 'sales/api/sale/create';
      const payload = {
        documents: app.documents,
        profile_id: app.user.profile_id,
        action_id: +app.$props.id,
        sale_id: !app.isNeedSales && app.action.photo_sales[0]
          && app.action.photo_sales[0].documents.length
          ? app.action.photo_sales[0].id : null,
      };

      app.$store.getters.axl.post(url, payload)
        .then(() => {
          app.$store.dispatch('ShowInfo', 'Фото добавлены');
        })
        .then(async () => {
          const { action } = await this.getAction();
          app.documents = !app.isNeedSales && action.photo_sales[0]
            ? action.photo_sales[0].documents : [];
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async getAction() {
      return this.$store.dispatch('sales/GetAction', {
        action_id: +this.$props.id,
        profile_id: this.user.profile_id,
      });
    },
  },
  async mounted() {
    const { action } = await this.getAction();
    this.documents = !this.isNeedSales && action.photo_sales[0]
      ? action.photo_sales[0].documents : [];
  },
  destroyed() {
    this.$store.dispatch('sales/ClearAction');
  },
};
